import {Router} from "@angular/router";
import {ComponentRef, ViewContainerRef} from "@angular/core";
import {Observable, timer} from "rxjs";
import scrollIntoView from "scroll-into-view-if-needed";

import {MixinConstructor} from "./mixin.define";
import {LINK_POPUP_DELAY, RESULT_LINKPOPUP, SearchParam} from "../defines/client.const";
import {DynamicComponentService} from "../services/dynamic-component/dynamic-component.service";
import {HunPopupComponent} from "../components/hun-popup/hun-popup.component";


type HunLinkMixinType = {
  router: Router,
  dynamicSvc: DynamicComponentService,
};

/**
 * 단일 mixin을 사용하는 경우의 정의.
 */
export const HunLinkMixin = HunLinkMixinFunction(
  class Parent {
    constructor(
      public router: Router,
      public dynamicSvc: DynamicComponentService,
    ) {
    }
  }
);

export function HunLinkMixinFunction<BaseType extends MixinConstructor<HunLinkMixinType>>(BaseClass: BaseType) {
  return class extends BaseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    private elRefHunLinkPopup: ComponentRef<HunPopupComponent> | null = null;


    /**
     *
     * @param hun - 훈
     * @param container - 링크 팝업창을 열 기준이 되는 요소
     */
    public OpenHunLink(hun: string, container: ViewContainerRef): Observable<RESULT_LINKPOPUP> {
      console.log('HunLinkMixin::OpenHunLink() : hun=', hun);

      return new Observable<RESULT_LINKPOPUP>(observer => {
        try {
          this.elRefHunLinkPopup = this.dynamicSvc.createComponent(HunPopupComponent, container);

          /******************************************************************************************
           * 팝업창이 닫힐 때 발생하는 이벤트 처리.
           */
          this.elRefHunLinkPopup.instance.close.subscribe((hun: string | null) => {
            console.log('HunLinkMixin::OpenHunLink() : hun=', hun);

            observer.next(RESULT_LINKPOPUP.POPUP_CLOSE);

            if (hun) {
              this.router.navigate(['/saseung',], {queryParams: {hun}}).then();

              observer.next(RESULT_LINKPOPUP.GOTO_LINK);
            }

            observer.complete();
            this.closeHunLinkPopup();
          });

          /******************************************************************************************
           * 화면에 초기화 된 후 (ngAfterViewInit()) 발생하는 이벤트 처리.
           */
          this.elRefHunLinkPopup.instance.viewInit.subscribe((nativeEl: HTMLElement) => {

            // 팝업창이 열리는 애니메이션이 끝난 뒤에 스크롤 해야 정확한 위치로 스크롤이 된다.
            timer(LINK_POPUP_DELAY).subscribe(() => {
              console.log('HunLinkMixin::OpenHunLink() : viewInit=', nativeEl);

              scrollIntoView(nativeEl, {
                behavior: 'smooth',
                block: 'end',
                scrollMode: 'if-needed',
              });
            });
          });

          /******************************************************************************************
           * 팝업창에 표시할 정보 설정.
           */
          this.elRefHunLinkPopup.instance.hun = hun;
          this.elRefHunLinkPopup.changeDetectorRef.detectChanges();
        } catch (err) {
          console.error('HunLinkMixin::OpenHunLink() : Failed to create popup', err);
          observer.error(err);
        }
      });
    }

    private closeHunLinkPopup(): void {
      if (this.elRefHunLinkPopup) {
        this.elRefHunLinkPopup.destroy();
        this.elRefHunLinkPopup = null;
      }
    }
  };
}
